import { SVGFC } from '@repo/toolkit/types'

const PenIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.0588 6.87997L16.5294 9.47712M12.4118 19H19M5.82353 15.5371L5 19L8.29412 18.1343L17.8355 8.10409C18.1443 7.7794 18.3178 7.33908 18.3178 6.87997C18.3178 6.42085 18.1443 5.98054 17.8355 5.65584L17.6939 5.50694C17.385 5.18235 16.9662 5 16.5294 5C16.0927 5 15.6738 5.18235 15.3649 5.50694L5.82353 15.5371Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default PenIcon
